import { render, staticRenderFns } from "./RegistrationRequestCommonInfoReadOnly.vue?vue&type=template&id=10d5a64f&scoped=true"
import script from "./RegistrationRequestCommonInfoReadOnly.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestCommonInfoReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d5a64f",
  null
  
)

export default component.exports